export const CART_POPUP_WIDGET_AUTO_DISMISS_TIMER_IN_MS = 5000;
export const CART_TO_PAYMENT_URL = "/payments/?order_total={0}&plan_id={1}";
export const HOME_PAGE_HEADER_SCROLL_OFFSET = 32;
export const SUBSCRIPTION_TAX_KEY = "subscription_item_tax";

export const NEW_RELIC_APPLICATION_ID = process.env.NEXT_PUBLIC_NEW_RELIC_APP_ID || "";
